import React from 'react';

export const NotAuthenticated: React.FunctionComponent = () => {
  return <>Not Authenticated</>;
};

export default NotAuthenticated;
